// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
	<path d="M6,10c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S7.1,10,6,10z M6,13c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S6.6,13,6,13z M12,10
		c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S13.1,10,12,10z M12,13c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1c0.1,0.5-0.3,0.9-0.8,1
		C12.1,13,12.1,13,12,13z M18,10c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S19.1,10,18,10z M18,13c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1
		c0.1,0.5-0.3,0.9-0.8,1C18.1,13,18.1,13,18,13z" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-more-actions-VCET7Nzo.js.map
